import classnames from 'classnames';
import React, { ComponentType, FC } from 'react';
import { MediaType } from '../../../../../constants/MediaType';
import { getFileMediaType } from '../../../../../utils/media-manager-sdk/items';
import { IFileThumbnail } from '../../../../common/Thumbnails/types';
import styles from './ListFileThumbnail.scss';
import { Empty } from './ListFileThumbnailComponents/Empty';
import { Labeled } from './ListFileThumbnailComponents/Labeled';
import { Music } from './ListFileThumbnailComponents/Music';
import { Picture } from './ListFileThumbnailComponents/Picture';
import { Video } from './ListFileThumbnailComponents/Video';

const selectThumbnailClassName = (mediaType: MediaType): string => {
  switch (mediaType) {
    case MediaType.Video:
    case MediaType.SecureVideo:
      return styles.video;

    case MediaType.Music:
    case MediaType.SecureMusic:
      return styles.music;

    case MediaType.Document:
    case MediaType.SecureDocument:
      return styles.document;

    case MediaType.Zip:
    case MediaType.SecureZip:
      return styles.zip;

    case MediaType.SWF:
      return styles.swf;

    default:
      return '';
  }
};

const selectListFileThumbnailComponent = (mediaType: MediaType): ComponentType<IFileThumbnail> => {
  switch (mediaType) {
    case MediaType.SecurePicture:
    case MediaType.Picture:
    case MediaType.VectorArt:
    case MediaType.SiteIcon:
      return Picture;

    case MediaType.SecureVideo:
    case MediaType.Video:
      return Video;

    case MediaType.SecureMusic:
    case MediaType.Music:
      return Music;

    case MediaType.SecureDocument:
    case MediaType.Document:
    case MediaType.SecureZip:
    case MediaType.Zip:
    case MediaType.SWF:
      return Labeled;

    default:
      return Empty;
  }
};

export const ListFileThumbnail: FC<IFileThumbnail> = ({
  file,
  dataHook = 'list-file-thumbnail',
  className,
  ...otherProps
}) => {
  const mediaType = getFileMediaType(file);
  const ThumbnailComponent = selectListFileThumbnailComponent(mediaType);

  return (
    <ThumbnailComponent
      file={file}
      className={classnames(selectThumbnailClassName(mediaType), className)}
      dataHook={dataHook}
      {...otherProps}
    />
  );
};
